export var HELP_CENTER_APP_IDENTIFIER = "help-center";